import { Grid, Paper, TableContainer, Typography as Type } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import BreadcrumbsComponent from "../../../Components/BreadCrumbs";
import LeftSideNav from "../../../Components/LeftSideNav";
import TopNavBar from "../../../Components/TopNavbar";
import Fonts from "../../../Config/Fonts";
import Strings from "../../../Config/Strings";
import { userStatus } from "../../../Constants/AppConstants";
import Colors from "../../../theme/Colors";
import { convertUTCToIST, formatDate, formattedDate } from "../../../Utils";

// Component for displaying each user detail item
const DetailItem = ({ label, value }) => (
  <Grid
    item
    xs={12}
    sm={18}
    style={{
      display: "flex",
      alignItems: "center",
      padding: "8px 0",
      width: "30vw",
    }}
  >
    <Type variant="subtitle1" style={labelInfoStyle}>
      <div>{label}</div>
    </Type>
    <Type
      style={{
        width: "100%",
        justifyContent: "start",
        display: "flex",
      }}
    >
      <div style={inputTextStyle}>
        :
        <p
          style={{
            fontSize: 16,
            fontWeight: "400",
            fontFamily: Fonts.Poppins,
            color: Colors.darkGray,
            marginLeft: "5px",
          }}
        >
          {value}
        </p>
      </div>
    </Type>
  </Grid>
);

const UserDetails = () => {
  const location = useLocation();
  const { user } = location?.state || {}; // Extract the user from location state
  const [breadcrumbs, setBreadcrumbs] = useState([]);

  useEffect(() => {
    if (user && user.user_first_name) {
      setBreadcrumbs([
        { key: "1", href: "/", text: "Customers" },
        { key: "2", href: `/`, text: `${user?.user_first_name} Details` },
      ]);
    }
  }, [user]);

  const PersonalDetailInformation = () => (
    <Grid
      container
      direction="column"
      spacing={2}
      style={userDetailsContainerStyle}
    >
      <DetailItem
        label="Name"
        value={`${user?.user_first_name} ${user.user_last_name}`}
      />
      <DetailItem label="Shop Name" value={user?.user_shop_name || "Nil"} />
      <DetailItem label="State" value={user?.user_state || "Nil"} />
      <DetailItem label="City" value={user?.user_city || "Nil"} />
      <DetailItem label="Mobile Number" value={user?.user_mobile_number} />
      <DetailItem
        label="Alternate Number"
        value={user?.alternateMobileNo || "Nil"}
      />
      <DetailItem label="Email ID" value={user?.user_email} />
    </Grid>
  );

  const AdditionalDetailInformation = () => (
    <Grid
      container
      spacing={2}
      direction="column"
      style={userDetailsContainerStyle}
    >
      <DetailItem label="GST No" value={"Nil"} />
      <DetailItem label="PAN Card Number" value={user?.user_city || "Nil"} />
      <DetailItem label="Pin code" value={"Nil"} />
      <DetailItem
        label="Status"
        value={
          <span style={statusBadgeStyle(user?.user_status_id)}>
            {userStatus[user?.user_status_id]?.label || "Unknown"}
          </span>
        }
      />
      <DetailItem
        label="Register Date"
        value={formatDate(user?.user_last_seen_date) || "Nil"}
      />
      <DetailItem
        label="Last order date"
        value={formatDate(user?.user_last_order_date) || "Nil"}
      />
      <DetailItem
        label="Last Seen"
        value={formatDate(user?.user_last_seen_date) || "Nil"}
      />
    </Grid>
  );

  return (
    <div style={mainContainerStyle}>
      <LeftSideNav />
      <div style={mainContentStyle}>
        <TopNavBar leftSideText="Customer Details" />
        <BreadcrumbsComponent breadcrumbs={breadcrumbs} />

        <TableContainer component={Paper} style={TableContainerStyle}>
          {/* User Personal Details */}
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <div style={{ width: "50%" }}>
              <h1 style={mainHeadingStyle}>Personal Details</h1>
              <PersonalDetailInformation />
            </div>

            <div style={{ width: "50%" }}>
              <h1 style={mainHeadingStyle}>Additional Information</h1>
              <AdditionalDetailInformation />
            </div>
          </div>

          <div>
            <h1 style={mainHeadingStyle}>Documents</h1>
          </div>

          {/* User Login Details */}
          <div style={{ marginTop: "80px", marginBottom: '40px' }}>
            <h1 style={mainHeadingStyle}>Customer Login Details</h1>

            <div style={outerWrapper}>
              <div style={tableWrapper}>
                <table style={table}>
                  <thead>
                    <tr>
                      <th style={tableHeaderStyle}>Sr No</th>
                      <th style={tableHeaderStyle}>Date</th>
                      <th style={tableHeaderStyle}>Login Time</th>
                      <th
                        style={{
                          ...tableHeaderStyle,
                          borderRight: "none", // Remove right border for the "Logout Time" header
                        }}
                      >
                        Logout Time
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    {user?.user_login_details?.length > 0 ? (
                      user.user_login_details.map((timeStamp, index) => {
                        const formattedUpdatedAt = formattedDate(
                          timeStamp?.login_timestamp
                        );
                        const formattedLoginTime = convertUTCToIST(
                          timeStamp.login_timestamp
                        );
                        const formattedLogoutTime = timeStamp.logout_timestamp
                          ? convertUTCToIST(timeStamp.logout_timestamp)
                          : "-";

                        return (
                          <tr key={index}>
                            <td
                              style={{
                                ...tableInputStyle,
                                borderBottom:
                                  index === user?.user_login_details?.length - 1
                                    ? "none"
                                    : "1px solid #D3D3D3",
                                borderRight: "1px solid #D3D3D3",
                              }}
                            >
                              {index + 1}
                            </td>
                            <td
                              style={{
                                ...tableInputStyle,
                                borderBottom:
                                  index === user?.user_login_details?.length - 1
                                    ? "none"
                                    : "1px solid #D3D3D3",
                                borderRight: "1px solid #D3D3D3",
                              }}
                            >
                              {formattedUpdatedAt || "-"}
                            </td>
                            <td
                              style={{
                                ...tableInputStyle,
                                borderBottom:
                                  index === user?.user_login_details?.length - 1
                                    ? "none"
                                    : "1px solid #D3D3D3",
                                borderRight: "1px solid #D3D3D3",
                              }}
                            >
                              {formattedLoginTime || "-"}
                            </td>
                            <td
                              style={{
                                ...tableInputStyle,
                                borderBottom:
                                  index === user?.user_login_details?.length - 1
                                    ? "none"
                                    : "1px solid #D3D3D3",
                                borderRight: "none", // Remove right border for the last column
                              }}
                            >
                              {formattedLogoutTime || "-"}
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan={4} style={emptyDataTextStyle}>
                          {Strings.NoDataFound}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </TableContainer>
      </div>
    </div>
  );
};

// CSS styles
const mainContainerStyle = {
  display: "grid",
  gridTemplateColumns: "20% 80%",
  height: "100vh",
  width: "100vw",
  overflow: "hidden",
};

const mainContentStyle = {
  backgroundColor: Colors.bgColor,
  display: "flex",
  flexDirection: "column",
};

const mainHeadingStyle = {
  fontSize: 24,
  fontWeight: "500",
  fontFamily: Fonts.Poppins, // Ensure this matches the loaded font
  color: Colors.headingBlackColor,
  display: "flex",
  borderBottom: "1px solid #ccc",
  marginBottom: "20px",
};

const TableContainerStyle = {
  width: "96%",
  height: "70%",
  border: "1px solid #ccc",
  borderRadius: "15px",
  boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
  padding: "12px 0px 0px 20px",
  marginLeft: "25px",
  marginTop: "15px",
};

const userDetailsContainerStyle = {
  backgroundColor: Colors.white,
  width: "50%",
  marginTop: "10px",
  marginLeft: "5px",
};

const labelInfoStyle = {
  fontSize: 16,
  fontWeight: "500",
  fontFamily: Fonts.Poppins,
  color: Colors.black,
  display: "flex",
  alignItems: "center",
  width: "80%",
};

const inputTextStyle = {
  fontSize: 16,
  fontWeight: "400",
  fontFamily: Fonts.Poppins,
  color: Colors.darkGray,
  display: "flex",
  alignItems: "center",
  width: "100%",
};

const tableHeaderStyle = {
  position: "sticky",
  top: 0,
  backgroundColor: Colors.white,
  color: Colors.breadCrumbsColor,
  textAlign: "center",
  fontSize: 12,
  fontWeight: 500,
  fontFamily: Fonts.Poppins,
  borderBottom: "1px solid #D3D3D3",
  borderRight: "1px solid #D3D3D3",
  padding: "10px 50px",
  paddingTop: "10px",
  paddingBottom: "10px",
};

const tableInputStyle = {
  fontSize: 12,
  fontWeight: 500,
  fontFamily: Fonts.Poppins,
  color: Colors.paginationTitle,
  borderBottom: "1px solid #D3D3D3",
  borderRight: "1px solid #D3D3D3",
  textAlign: "center",
  paddingTop: "10px",
  paddingBottom: "10px",
  marginLeft: "5px",
};

const emptyDataTextStyle = {
  fontSize: 14,
  fontWeight: 400,
  fontFamily: Fonts.Poppins,
  color: Colors.darkGray,
  textAlign: "center",
  marginTop: "20px",
};

const table = {
  minWidth: "110%",
};

const outerWrapper = {
  margin: "12px",
  marginRight: "20px",
  border: "1px solid #D3D3D3",
  borderRadius: "12px",
};

const tableWrapper = {
  overflowY: "hidden",
  overflowX: "hidden",
};

const statusBadgeStyle = (statusId) => ({
  color: userStatus[statusId]?.color,
  fontSize: 16,
  fontWeight: 500,
  fontFamily: Fonts.Poppins,
});

export default UserDetails;
